import { set, get, uniqueId, forEach, map } from 'lodash';

import TopNavigationModel from 'models/TopNavigation';
import actions from 'state/constants';
import initialState from 'state/initialState';

// Traverses navigation tree and appends unique ids to each node, runs the navigation tree through its model, and builds a normalized map of nodes by their ids
const mungeTreeData = treeData => {
  const nodesById = {};

  const recursivelyAssignIdToNavigationNodes = node => {
    // Generate Unique id for node
    const id = uniqueId(`top-navigation-node-`);

    // Set id on node
    set(node, 'id', id);

    // Recursively process child nodes
    forEach(get(node, ['subNavigations']), recursivelyAssignIdToNavigationNodes);

    return node;
  };

  const treeDataWithId = recursivelyAssignIdToNavigationNodes(treeData);

  // Run the navigation tree through its model, to take advantage of its abstractions and schema validation
  const modeledData = new TopNavigationModel(treeDataWithId).toPlainObject();

  const recursivelyBuildNodeMap = node => {
    const id = get(node, 'id');

    // Add node to map, keyed by its id
    set(nodesById, id, { ...node });

    // Recursively process child nodes
    forEach(get(node, ['subNavigations']), recursivelyBuildNodeMap);
  };

  recursivelyBuildNodeMap(modeledData);

  // Flatten map items to only reference ids instead of nested nodes
  forEach(nodesById, node => {
    set(node, 'subNavigations', map(get(node, 'subNavigations'), 'id'));
  });

  return {
    nodeTree: modeledData,
    nodesById,
  };
};

const setTopNavigationData = (state, action) => ({
  ...state,
  ...mungeTreeData(get(action, ['payload', 'data'])),
});

const setCurrentTopNavigationNode = (state, action) => ({
  ...state,
  currentNodeId: get(action, ['payload', 'id']),
});

// Close nav if opened, open nav if closed
const toggleMobileNavigation = state => {
  const isOpen = !!get(state, ['currentNodeId']);
  const level0NodeId = get(state, ['nodeTree', 'id']);

  // If already opened then close it, if closed then set current node to the top-most node
  const currentNodeId = isOpen ? null : level0NodeId;

  return {
    ...state,
    currentNodeId,
  };
};

const closeTopNavigation = state => ({
  ...state,
  currentNodeId: null,
});

const closeSearchQuickResults = state => ({
  ...state,
  isSearchQuickResultsOpen: false,
});

const openSearchQuickResults = state => ({
  ...state,
  isSearchQuickResultsOpen: true,
});

export const reducer = (state = initialState.geofencing, action) => {
  switch (action.type) {
    case actions.SET_TOP_NAVIGATION_DATA:
      return setTopNavigationData(state, action);
    case actions.SET_CURRENT_TOP_NAVIGATION_NODE:
      return setCurrentTopNavigationNode(state, action);
    case actions.TOGGLE_MOBILE_TOP_NAVIGATION:
      return toggleMobileNavigation(state, action);
    case actions.CLOSE_TOP_NAVIGATION:
      return closeTopNavigation(state, action);
    case actions.OPEN_SEARCH_QUICK_RESULTS:
      return openSearchQuickResults(state, action);
    case actions.CLOSE_SEARCH_QUICK_RESULTS:
      return closeSearchQuickResults(state, action);
    default:
      return state;
  }
};

export default reducer;
